<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>[{{ cardName }}]를</span>
                    <span>이마티콘 대표카드로</span>
                    <span>저장하시겠습니까?</span>
                </div>
            </div>
            <div class="button-wrap">
              <button @click="$emit('toggleChangeRepresentativePopup')" class="button-bg-gray">아니요</button>
              <button @click="$emit('changeRepresentativeCard')" class="button-bg-yellow">예</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ChangeRepresentativePopup',
  props: {
    cardName: ''
  }
};
</script>

<style lang="scss" scoped>
    @import '/src/assets/styles/global.scss';
    @import '/src/assets/styles/common/bottomButton.scss';
    .absolute { position: fixed; bottom: 0; width: 100%; }
    .popup-wrap {
        min-height: rem(66);
        border-radius: rem(24) rem(24) 0 0;
        background-color: $color-white;
        div {
            padding: rem(40) rem(24);
            text-align: center;
            span {
                display: block;
                @include font-size(rem(16), rem(22), 700);
                color: $color-black-400;
            }
        }
    }
</style>